export default "__VITE_ASSET__BFfoVOLI__"